import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

interface ClosePromptDialogProps {
  open: boolean;
  parentType: "popout" | "detached-tab";
  playerClosed?: boolean;
  onReturn: () => void;
  onClose: () => void;
}

export default function ClosePromptDialog({
  open,
  parentType,
  playerClosed = false,
  onReturn,
  onClose,
}: Readonly<ClosePromptDialogProps>) {
  const returnLabel = parentType === "popout" ? "Return to main window" : "Return to player";
  const showReturn = !playerClosed;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Close this window?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          {showReturn
            ? "You can return this view to its parent window or close it entirely."
            : "The player window has been closed. You can close this window."}
        </Typography>
      </DialogContent>
      <DialogActions>
        {showReturn && (
          <Button onClick={onReturn} variant="outlined" size="small">
            {returnLabel}
          </Button>
        )}
        <Button onClick={onClose} variant="contained" color="error" size="small">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
